import { render } from "./purchaseSeparately.vue?vue&type=template&id=3b451ca6&scoped=true"
import script from "./purchaseSeparately.vue?vue&type=script&lang=js"
export * from "./purchaseSeparately.vue?vue&type=script&lang=js"

import "./purchaseSeparately.vue?vue&type=style&index=0&id=3b451ca6&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b451ca6"]])

export default __exports__